import * as React from 'react';
import {styled} from '@mui/material/styles';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion, {AccordionProps} from '@mui/material/Accordion';
import MuiAccordionSummary, {AccordionSummaryProps,} from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import "./halfcoloraccordion.scss";
import HorizontalDivider from "../horizontaldivider/horizontaldivider";
import DotIndicator from "../dotindicator/dotindicator";

const HalfColorAccordion = styled((props: AccordionProps) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
))(({theme}) => ({
    border: `0px solid ${theme.palette.divider}`,
    '&:not(:last-child)': {
        borderBottom: 0,
    },
    '&:before': {
        display: 'none',
    }, '&.Mui-expanded': {
        backgroundColor: "#fff",
        color: "#0F1142",
    },
    marginBottom: '25px',
    boxShadow: '0px 24px 64px #EDF2F5',
    borderRadius: '12px',
    backgroundColor: "#fff",
    color: "#000",
    transition: 'all ease 0.5s',
    width: '90%',
    margin: '25px auto',
}));

const AccordionSummary = styled((props: AccordionSummaryProps) => (
    <MuiAccordionSummary
        {...props}
        expandIcon={<ArrowForwardIosSharpIcon sx={{fontSize: '0.9rem'}}/>}
    />
))(({theme}) => ({
    flexDirection: 'row',
    '& .MuiAccordionSummary-expandIconWrapper': {
        transform: 'rotate(90deg)',
        color: "#000",
        transition: 'all ease 0.5s'
    },
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
        transform: 'rotate(-90deg)',
        color: "#fff",
    },
    '& .MuiAccordionSummary-content': {
        marginLeft: theme.spacing(1),
    }, '&.Mui-expanded': {
        backgroundColor: "#2B2D42",
        color: '#fff'
    },
    padding: '10px 20px',
    fontWeight: '600',
    borderRadius: '12px',
    textAlign: 'right',
    transition: 'all linear 0.3s'
}));

const AccordionDetails = styled(MuiAccordionDetails)(() => ({
    padding: '30px',
    color: "#D5D5D9",
    borderRadius: '0 0 12px 12px',
    '& p': {
        fontWeight: '300',
        lineHeight: '2'
    },
}));

interface IHalfAccordionCard {
    custom?: boolean
}

export default function HalfAccordionCard({custom}: IHalfAccordionCard) {
    const [expanded, setExpanded] = React.useState<string | false>('panel4');

    const handleChange =
        (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
            console.log(event)
            setExpanded(newExpanded ? panel : false);
        };

    return custom ? (
        <div className="DropDown">
            <HalfColorAccordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
                <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
                    <div className="d-flex align-items-center gap-3">
                        <img src={require("../../assets/images/icons/SmileFaceLight1.svg").default}
                             style={{width: '30px'}}
                             alt="" className="align-middle"/>
                        <Typography>لیست صفحات منتخب برای تبلیغات شما</Typography>
                    </div>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography>
                        <div className="d-flex align-items-center mb-2">
                            <DotIndicator size="16px"/>
                            <span className="dark-text">این متن برای تستی است</span>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                            <DotIndicator size="16px"/>
                            <span className="dark-text">گزینه های داخل گوگل ادز هست</span>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                            <DotIndicator size="16px"/>
                            <span className="dark-text">من خیلی گشنمه بزارید برم</span>
                        </div>
                    </Typography>
                </AccordionDetails>
            </HalfColorAccordion>
        </div>
    ) : (
        <div className="DropDown">
            <HalfColorAccordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
                <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
                    <div className="d-flex align-items-center gap-3">
                        <img src={require("../../assets/images/icons/SmileFaceLight1.svg").default}
                             style={{width: '30px'}}
                             alt="" className="align-middle"/>
                        <Typography>۵ میلیون تومان</Typography>
                    </div>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography>
                        <div className="d-flex align-items-center mb-2">
                            <DotIndicator size="16px"/>
                            <span className="dark-text">این متن برای تستی است</span>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                            <DotIndicator size="16px"/>
                            <span className="dark-text">گزینه های داخل گوگل ادز هست</span>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                            <DotIndicator size="16px"/>
                            <span className="dark-text">من خیلی گشنمه بزارید برم</span>
                        </div>
                    </Typography>
                </AccordionDetails>
            </HalfColorAccordion>
            <HalfColorAccordion expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
                <AccordionSummary aria-controls="panel2d-content" id="panel2d-header">
                    <div className="d-flex align-items-center gap-3">
                        <img src={require("../../assets/images/icons/SmileFaceLight2.svg").default}
                             style={{width: '30px'}} alt="" className="align-middle"/>
                        <Typography>۱۰ میلیون تومان</Typography>
                    </div>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography>
                        <div className="d-flex align-items-center mb-2">
                            <DotIndicator size="16px"/>
                            <span className="dark-text">این متن برای تستی است</span>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                            <DotIndicator size="16px"/>
                            <span className="dark-text">گزینه های داخل گوگل ادز هست</span>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                            <DotIndicator size="16px"/>
                            <span className="dark-text">من خیلی گشنمه بزارید برم</span>
                        </div>
                    </Typography>
                </AccordionDetails>
            </HalfColorAccordion>
            <HalfColorAccordion expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
                <AccordionSummary aria-controls="panel3d-content" id="panel3d-header">
                    <div className="d-flex align-items-center gap-3">
                        <img src={require("../../assets/images/icons/SmileFaceLight3.svg").default}
                             style={{width: '30px'}} alt="" className="align-middle"/>
                        <Typography>۱۵ میلیون تومان</Typography>
                    </div>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography>
                        <div className="d-flex align-items-center mb-2">
                            <DotIndicator size="16px"/>
                            <span className="dark-text">این متن برای تستی است</span>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                            <DotIndicator size="16px"/>
                            <span className="dark-text">گزینه های داخل گوگل ادز هست</span>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                            <DotIndicator size="16px"/>
                            <span className="dark-text">من خیلی گشنمه بزارید برم</span>
                        </div>
                    </Typography>
                </AccordionDetails>
            </HalfColorAccordion>
            <HalfColorAccordion expanded={expanded === 'panel4'} onChange={handleChange('panel4')}>
                <AccordionSummary aria-controls="panel4d-content" id="panel4d-header">
                    <div className="d-flex align-items-center gap-3">
                        <img src={require("../../assets/images/icons/SmileFaceDark4.svg").default}
                             style={{width: '30px'}} alt="" className="align-middle"/>
                        <Typography>آگاه سازی نسبت به برند</Typography>
                    </div>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography>
                        <div className="d-flex align-items-center mb-2">
                            <DotIndicator size="16px"/>
                            <span className="dark-text">این متن برای تستی است</span>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                            <DotIndicator size="16px"/>
                            <span className="dark-text">گزینه های داخل گوگل ادز هست</span>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                            <DotIndicator size="16px"/>
                            <span className="dark-text">من خیلی گشنمه بزارید برم</span>
                        </div>
                    </Typography>
                </AccordionDetails>
            </HalfColorAccordion>
            <br />
            <HorizontalDivider/>
        </div>
    )
}